<template>
    <div >
        <el-carousel :interval="5000" indicator-position="none" :height="screenheight">
            <el-carousel-item v-for="(item, index) in qbsj_lbtp" :key="index">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="">
            </el-carousel-item>
        </el-carousel>

        <div style="width: 1200px; margin: 100px auto;">
            <el-tabs v-model="activeName">
                <el-tab-pane v-for="(item, index) in category_arr" :key="index" :label="item.name" :name="item.id"></el-tab-pane>
            </el-tabs>
            <div class="mt40 flx shouxing" v-for="(item, index) in data_list" :key="index" @click="toinfo(item.id)">
                <div style="width: 200px; height: 120px;">
                    <img style="width: 200px; height: 120px;" :src="item.format_img" alt="">
                </div>
                <div class="ml30" style="width: 960px;">
                    <div>{{item.name}}</div>
                    <div class="mt40 fs16 dv2" style="color: #878787; line-height: 26px;" v-html="item.content"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'Allstore',    
    data () {
        return {
            category_arr: [
                {id: '0', name: '全部'},
            ],
            activeName: '0',
            screenheight: '500px',
            qbsj_lbtp: '',
            data_list: '',
            screenWidth: null
        }
    },
    methods:{
        getData2() {
            this.$post('index.php?s=/api/index/qbsj_jh', {
                wxapp_id: 10001,
                coop_id: this.id
            })
            .then((res) => {
                if(res.code == 1) {
                    var a_data = res.data.list;
                    for (let i = 0; i < a_data.length; i++) {
                        if(a_data[i].content) {
                            a_data[i].content = this.showHtml(a_data[i].content);
                            a_data[i].content = a_data[i].content.replace(/<\/?br[^>]*>/gi,'')
                        }
                    }
                    this.qbsj_lbtp = res.data.qbsj_lbtp;
                    this.data_list = a_data;
                }
            }) 
        },
        toinfo(id) {
            this.$router.push({
                path: '/storeinfo',
                query: {
                    id: id
                }
            })
        },
        showHtml(str){
            return str
            .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g,"<")
            .replace(/&gt;/g,">")
            .replace(/&quot;/g,"\"")
            .replace(/&#39;/g, "\'")
            .replace(/<\/?p[^>]*>/gi,'')
            .replace(/<\/?hr[^>]*>/gi,'')
            .replace(/<\/?img[^>]*>/gi,'')
            .replace(/&amp;nbsp;/g,'\u3000')
        },
    },
    watch: {
        screenWidth: {
            handler: function (val, oldVal) {
                if (val*500/1920 < 321.5) {
                    this.screenheight = '321.5px';
                } else {
                    this.screenheight = val*500/1920 + 'px';
                }
            },
        },
    },
    created() {
        var data = this.$route.query;
        this.id = data.id;
        this.getData2();
        document.title = '全部商家';
    },
    mounted() {
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })()
        }
	},
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/bigshot/allstore.vue